import { useEffect, useRef, useState } from "react";
import { Button, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import spinnerTitle from "../others/spinnerTitle";
import { useSettings } from "context/SettingsContext";
import * as apiSetting from "api/apiSettings";
import { useToast } from "context/ToastContext";

const OffRateNewRate = ({setShow}) => {
    const { t } = useTranslation(['Rate', 'common']);
    const { showToast } = useToast();
    const { localSettings, getSettings } = useSettings();
    const [ isSetRate, setIsSetRate ] = useState(false);
    const [ showNewRate, setShowNewRate ] = useState(false);
    const refInput = useRef();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!refInput?.current?.value) return;
        setIsSetRate(true);
        const resRate = await apiSetting.setRate(refInput.current.value);
        await getSettings();
        if (resRate?.stat) {
            showToast(t('messSetRate'), 'success');
            setShow(false);
        }
        else showToast(t('common:messError'), 'danger')
        
        setIsSetRate(false);
    }  

    useEffect(()=>{
        if (showNewRate) refInput?.current?.focus();
    },[showNewRate])

    return (
        <div className="px-3 pb-3 text-end">
            <p className="mb-2 fs-10 text-muted text-start">{t('hintUahMode')}</p>

            <div className="d-flex">
                <div className="w-100">    
                    {showNewRate && (
                    <form onSubmit={handleSubmit}>
                    <input className="form-control" 
                        ref={refInput}
                        required
                        disabled={isSetRate}    
                        type="number"
                        minimum="0"
                        step="0.01"
                        defaultValue={(localSettings?.RATE?.current||0).toFixed(2)}/>
                    </form>)}       
                </div>
                <div style={{width:'220px'}}>

                    {showNewRate
                        ? (<Button
                            variant="danger"
                            disabled={isSetRate}
                            onClick={handleSubmit}>
                            {spinnerTitle(
                                (<><i className="bi bi-currency-dollar fs-14 me-2"></i>{t('setRate')}</>), 
                                isSetRate, 
                                t('setRate'))}

                        </Button> 

                        )

                        : (<Button
                            onClick={()=>{
                                setShowNewRate(true);
                                refInput?.current?.focus();
                            }}>
                        <i className="bi bi-currency-dollar fs-14 me-2"></i>{t('addRate')}
                        </Button> )}
                </div>
            </div>
            
        </div>)
}

export default OffRateNewRate;